import { SvgIcon } from "@mui/material";
import { ReactComponent as Icon } from "@/assets/icons/actions/SaveIcon.svg";

export const SaveIconComponent = () => {
	return <SvgIcon className="!w-[20px] !h-[20px]" component={Icon} viewBox={"-3 -3 24 24"} />;
};
